import { SeoLinkContainer, StyledAnchor } from './SeoLink.style'

interface SeoLinkProps {
  href: string
  label: string
}

export const SeoLink = ({ href, label }: SeoLinkProps) => (
  <SeoLinkContainer>
    <StyledAnchor href={href} passHref>
      {label}
    </StyledAnchor>
  </SeoLinkContainer>
)
